var map = {
	"./attraversamento-pedonale-so.png": 9218,
	"./attraversamento-pedonale.png": 1049,
	"./dare-precedenza-so.png": 8828,
	"./dare-precedenza.png": 3058,
	"./diritto-precedenza-senso-unico-alternato.png": 1870,
	"./divieto-accesso.png": 6136,
	"./divieto-sorpasso-auto.png": 2379,
	"./divieto-sorpasso-autocarri.png": 5518,
	"./divieto-sosta-fermata.png": 2126,
	"./divieto-sosta.png": 521,
	"./divieto-transito-autocarri.png": 6916,
	"./divieto-transito-limite-altezza.png": 4170,
	"./divieto-transito-limite-larghezza.png": 787,
	"./divieto-transito-limite-peso.png": 9333,
	"./divieto-transito.png": 8837,
	"./dosso-so.png": 3647,
	"./fermata-bus-so.png": 4323,
	"./lanterna-semaforica.png": 8876,
	"./limite-vel-20.png": 8417,
	"./limite-vel-30.png": 3958,
	"./limite-vel-40.png": 7387,
	"./limite-vel-50.png": 2672,
	"./limite-vel-60.png": 4885,
	"./limite-vel-70.png": 9434,
	"./limite-vel-80.png": 3423,
	"./obbligo-dare-precedenza-senso-unico-alternato.png": 3110,
	"./obbligo-direzione-diritto-dx.png": 8391,
	"./obbligo-direzione-diritto-sx.png": 3530,
	"./obbligo-direzione-diritto.png": 1852,
	"./obbligo-direzione-dx-sx.png": 7717,
	"./obbligo-direzione-dx.png": 7665,
	"./obbligo-direzione-sx.png": 7648,
	"./obbligo-passaggio-dx-sx.png": 3544,
	"./obbligo-passaggio-dx.png": 9114,
	"./obbligo-passaggio-sx.png": 9031,
	"./parcheggio-disabili-so.png": 2218,
	"./parcheggio-merci-so.png": 6549,
	"./parcheggio.png": 8675,
	"./passo-carrabile.png": 7984,
	"./pericolo-attraversamento-pedonale.png": 8051,
	"./pericolo-doppia-curva-dx.png": 7324,
	"./pericolo-doppia-curva-sx.png": 4095,
	"./pericolo-doppio-senso.png": 6390,
	"./pericolo-dosso_cunetta_strada-dissestata.png": 243,
	"./pericolo-intersezione-con-precedenza-dx-sx.png": 5521,
	"./pericolo-intersezione-con-precedenza-dx.png": 557,
	"./pericolo-intersezione-con-precedenza-sx.png": 6836,
	"./pericolo-lanterna-semaforica.png": 4738,
	"./pericolo-lavori-in-corso.png": 9144,
	"./pericolo-strada-sdrucciolevole.png": 8397,
	"./pericolo-strettoia-dx-sx.png": 9380,
	"./pericolo-strettoia-dx.png": 902,
	"./pericolo-strettoia-sx.png": 5531,
	"./pericolo.png": 8471,
	"./rotatoria.png": 7199,
	"./senso-unico-dx.png": 2564,
	"./senso-unico-sx.png": 9277,
	"./stop-so.png": 8025,
	"./stop.png": 8552,
	"./strada-senza-sbocco.png": 8679
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6476;